var map = {
	"./blue50.png": "93b5",
	"./blue60.png": "3302",
	"./blue70.png": "123b",
	"./darkblue30.png": "bd13",
	"./darkblue50.png": "d7ed",
	"./darkblue70.png": "4e31",
	"./green50.png": "8352",
	"./green60.png": "bde5",
	"./green70.png": "c948",
	"./grey40.png": "555c",
	"./grey70.png": "e816",
	"./grey80.png": "f57b",
	"./red50.png": "5abe",
	"./red60.png": "d44d",
	"./red70.png": "3400",
	"./yellow50.png": "6340",
	"./yellow60.png": "a2c6",
	"./yellow70.png": "52bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5bf";